
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("赠送记录列表", ["赠送记录管理;gift_records"])
    })

    const store = useStore()
    const router = useRouter()
    const tableData = ref([])

    const formData = ref({
      name: "",
      mobile: "",
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    let date = new Date()
    let from = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
    let to = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)

    const duration = ref([
      from,
      to,
    ])

    const query = () => {
      store
        .dispatch(Actions.GET_GIFT_RECORDS, {
          ...formData.value,
          ...page.value,
          from: `${duration.value[0].toLocaleDateString()} ${duration.value[0].getHours()}:${duration.value[0].getMinutes()}:${duration.value[0].getSeconds()}`,
          to: `${duration.value[1].toLocaleDateString()} ${duration.value[1].getHours()}:${duration.value[1].getMinutes()}:${duration.value[1].getSeconds()}`,
        })
        .then(() => {
          tableData.value = store.getters.currentGiftRecords
          page.value.totalResult = store.getters.currentGiftRecordCount
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    };

    query()

    const submit = () => {
      query()
    }

    const newGiftRecord = () => {
      router.push({ name: "gift_record_new" })
    }

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      query()
    }

    const onCancel = () => {
      formData.value.name = ''
      formData.value.mobile = ''
    }

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            hour = '' + d.getHours(),
            minute = '' + d.getMinutes(),
            second = '' + d.getSeconds()

        if (month.length < 2) 
            month = '0' + month
        if (day.length < 2) 
            day = '0' + day
        if (hour.length < 2) 
            hour = '0' + hour
        if (minute.length < 2) 
            minute = '0' + minute
        if (second.length < 2) 
            second = '0' + second

        return [year, month, day, hour, minute, second].join('')
    }

    const onDownload = () => {
      let params = {
        ...formData.value,
        from: `${duration.value[0].toLocaleDateString()} ${duration.value[0].getHours()}:${duration.value[0].getMinutes()}:${duration.value[0].getSeconds()}`,
        to: `${duration.value[1].toLocaleDateString()} ${duration.value[1].getHours()}:${duration.value[1].getMinutes()}:${duration.value[1].getSeconds()}`,
      }

      store
        .dispatch(Actions.GET_DOWNLOAD_GIFT_RECORDS, params)
        .then(() => {
          const blob = new Blob([store.getters.currentDownloadGiftRecords], { type: "application/xlsx" });
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = `gift_records_${formatDate(Date().toString())}.xlsx`
          link.click();
          URL.revokeObjectURL(link.href)
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        })
    }

    const abortDialog = ref({
      visible: false,
      record: null as any,
      reason: '',
      loading: false
    })

    const handleAbort = (row) => {
      abortDialog.value.record = row
      abortDialog.value.reason = ''
      abortDialog.value.visible = true
    }

    const confirmAbort = () => {
      if (!abortDialog.value.record) return

      abortDialog.value.loading = true

      store
        .dispatch(Actions.ABORT_GIFT_RECORD, {
          id: abortDialog.value.record.id,
          reason: abortDialog.value.reason
        })
        .then(() => {
          Swal.fire({
            text: "撤回成功",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "确定",
            customClass: {
              confirmButton: "btn fw-bold btn-light-success",
            },
          })
          abortDialog.value.visible = false
          abortDialog.value.loading = false
          // 刷新列表
          query()
        })
        .catch((error) => {
          abortDialog.value.loading = false
          Swal.fire({
            text: (error instanceof Error ? error.message : error) || "撤回失败",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "确定",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          })
        })
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    return {
      tableData,
      formData,
      submit,
      newGiftRecord,
      page,
      onPageChange,
      onCancel,
      onDownload,
      duration,
      abortDialog,
      handleAbort,
      confirmAbort,
      formatPrice
    }
  },
})
